import { IconButton } from '@chakra-ui/react';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { CellContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import invariant from 'tiny-invariant';
import SparkelIcon from '../../common/icon/SparkelIcon';
import { isEditableTableMeta, isEditingRow } from '../../table/Table';
import { TableEntry } from './OrderEntriesPanel';

export const ExpanderCell = ({
  row,
  table: {
    options: { meta: tableMeta },
  },
}: CellContext<TableEntry, unknown>): ReactNode => {
  if (!row.getCanExpand()) {
    return null;
  }
  invariant(isEditableTableMeta(tableMeta));
  return (
    <IconButton
      ml={2 * row.depth}
      aria-label={`Toggle row expansion for ${row.original.name}`}
      icon={
        <SparkelIcon
          icon={row.getIsExpanded() ? faAngleDown : faAngleRight}
          color={
            tableMeta.isEditing && !isEditingRow(row, tableMeta)
              ? ['gray.200', 'gray.600']
              : ['gray.600', 'white']
          }
        />
      }
      _hover={{ backgroundColor: 'none' }}
      variant="ghost"
      size="xs"
      onDoubleClick={(event) => {
        event.stopPropagation();
      }}
      onClick={(e) => {
        // Prevent expansion from toggling row
        e.stopPropagation();
        row.toggleExpanded();
      }}
    />
  );
};
